import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const ass = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            'Partnerwerkstaetten in Ihrer Naehe': 'ASS Partnerwerkstätten in Ihrer Nähe',
            hero: {
                'title': 'Willkommen bei der Werkstatt-Buchung von ASS',
            },
            layout: {
                backText: 'Zurück zu ichbindeinauto.de'
            },
            linkToHome: 'https://www.ichbindeinauto.de/'
        },
    }
}
